<template>
    <v-container>
        <v-layout align-center justify-center fill-height>
            <v-flex xs12 sm7 md6 lg5 xl3>
                <v-card class="elevation-5">
                    <v-toolbar class="mb-5" dark color="primary">
                        <v-toolbar-title>
                            {{ $t('mensaje_login')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-img
                            class="ml-4 mr-4"
                            :src="require('../assets/intLogo.png')"
                            height="250px"
                            contain
                    ></v-img>
                    <v-card-text>
                        <v-form class="mb-4" @submit.prevent="login">
                            <v-text-field
                                    autofocus
                                    v-model="correo"
                                    name="correo"
                                    prepend-icon="person"
                                    label="E-Mail"
                                    :error-messages="errores.email"
                            >
                            </v-text-field>
                            <v-text-field
                                    v-model="password"
                                    name="password"
                                    prepend-icon="lock"
                                    :label="$t('password')"
                                    :type="show ? 'text' : 'password'"
                                    :append-icon="show ? 'visibility' : 'visibility_off'"
                                    :error-messages="errores.password"
                                    @click:append="show = !show">
                            </v-text-field>
                            <v-alert
                                    :value=alerta
                                    type="warning"
                                    outline
                                    transition="scale-transition"
                            >
                                {{ errores.non_field_errors }}
                            </v-alert>

                            <v-card-actions>
                                <v-flex>
                                    <span>{{$t('mensaje_olvidar_contrasena')}}</span>
                                    <br>
                                    <span>{{$t('mensaje_link_restablecer1')}} <a href="/password_reset">{{$t('mensaje_link_restablecer2')}}</a> {{$t('mensaje_link_restablecer3')}}</span>
                                </v-flex>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                            <v-btn :loading="loading" color="primary" type="submit">{{$t('ingresar')}}</v-btn>
                        </v-form>

                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {AUTH_REQUEST} from '../store/actions/auth'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    Vue.use(VeeValidate)


    export default {
        name: 'Login',
        data: () => ({
            show: false,
            alerta: false,
            correo: '',
            password: '',
            errores: [],
            loading: false
        }),
        methods: {
            login: function () {
                this.loading = true
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$store.dispatch(AUTH_REQUEST, {email: this.correo, password: this.password})
                            .then(ok => {
                                this.loading = false
                                if(localStorage.getItem('path_confirmed') !== null){
                                    this.$router.push({ path: localStorage.getItem('path_confirmed')})
                                    localStorage.removeItem('path_confirmed')
                                }
                                else
                                if(localStorage.getItem('path_concretar') !== null){
                                    this.$router.push({ path: localStorage.getItem('path_concretar')})
                                    localStorage.removeItem('path_concretar')
                                }
                                else
                                if(localStorage.getItem('path_authorized_access') !== null){
                                    this.$router.push({ path: localStorage.getItem('path_authorized_access')})
                                    localStorage.removeItem('path_authorized_access')
                                }
                                else
                                if(localStorage.getItem('path_authorized_access_no_code') !== null){
                                    this.$router.push({ path: localStorage.getItem('path_authorized_access_no_code')})
                                    localStorage.removeItem('path_authorized_access_no_code')
                                }
                                else
                                    this.$router.push({ name: 'home'})
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data){
                                    this.errores = error.response.data
                                    this.loading = false
                                    if(error.response.data['non_field_errors'] != null){
                                        this.alerta = true
                                        setTimeout(this.clear, 2000);
                                        this.loading = false
                                    }
                                }
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                    this.loading = false
                });
            },
            clear: function(){
                this.alerta = false
                this.errores = []
                this.$validator.reset()
            }
        }
    }
</script>
